import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'

const classNames = new BEMHelper('Tile')

const propTypes = {
    className: PropTypes.string,
    title: PropTypes.node,
    description: PropTypes.string,
    descriptionSmall: PropTypes.string,
    children: PropTypes.node,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    id: PropTypes.string,
    trackClick: PropTypes.function,
}

const defaultProps = {
    component: 'div',
}

function Tile(props) {
    const {
        title,
        id,
        description,
        descriptionSmall,
        link,
        analyticsName,
        children,
        className,
        trackClick,
        component: Component,
        ...rest
    } = props

    return (
        <Component className={classNames(null, null, className)} {...rest} onClick={() => trackClick(analyticsName)}>
            <div className={classNames('textWrapper', id)}>
                <div className={classNames('title', id)}>{title}</div>
                {descriptionSmall ? (
                    <Fragment>
                        <div className={classNames('description', [id, 'small' ])}>
                            {descriptionSmall}
                        </div>
                        <div className={classNames('description', [id, 'large' ])}>
                            {description}
                        </div>
                    </Fragment>
                ) : (
                    <div className={classNames('description', id)}>{description}</div>
                )}
                {link && <div className={classNames('link', id)}>{link}</div>}
            </div>
            {children ? <div className={classNames('content', id)}>{children}</div> : null}
        </Component>
    )
}

Tile.propTypes = propTypes
Tile.defaultProps = defaultProps

export default Tile
